module.exports = __webpack_public_path__ + "img/Lessonpreparation.dcee6ff5.png";